export function isHourlyExceedingWorkDay(
  startTime?: string | null,
  endTime?: string | null,
  workDayMinutes?: number,
): boolean {
  if (!startTime || !endTime || !workDayMinutes) return false;
  const [sh, sm] = startTime.split(':').map(Number);
  const [eh, em] = endTime.split(':').map(Number);
  const leaveMinutes = eh * 60 + em - (sh * 60 + sm);
  return leaveMinutes >= workDayMinutes;
}
